module.exports = __webpack_public_path__ + "img/trends_0.5748c610.jpg";